import React from "react";
import { styled } from "@mui/system";
import MUIAlertTitle, { AlertTitleProps } from "@mui/material/AlertTitle";

export const AlertTitle = styled(
  (props: AlertTitleProps) => <MUIAlertTitle {...props} />,
  {
    name: "AlertTitle",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({
  "&.MuiAlertTitle-root": {
    ...theme.typography["body"],
    color: theme.palette.primary.main,
  },
}));
